type IOrderStatus = {
    translations: any;
    orderStatus: string;
};

const OrderStatus = ({ translations, orderStatus }: IOrderStatus) => {
    return (
        <span
            className={`inline-flex whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ${
                orderStatus.toLowerCase() === 'completed' ||
                orderStatus.toLowerCase() === 'released' ||
                orderStatus.toLowerCase() === 'exchanged'
                    ? 'bg-green-100 text-green-800'
                    : orderStatus.toLowerCase() === 'cancelled'
                      ? 'bg-red-100 text-red-800'
                      : orderStatus.toLowerCase() === 'pending'
                        ? 'bg-blue-100 text-blue-800'
                        : 'bg-gray-100 text-gray-800'
            }`}
        >
            {translations[
                `customerServiceOrderStatus${
                    orderStatus.charAt(0).toUpperCase() +
                    orderStatus.slice(1).toLowerCase()
                }`
            ] || orderStatus}
        </span>
    );
};

export default OrderStatus;
